import { useEffect, useState } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Divider,
    Checkbox,
    Button,
    Modal,
    Popconfirm
} from "antd";

import { recordError } from "src/utils/logService";
import lookupApi from "../../../services/citizenScienceLookupService";
import { csParticipRoleEnum } from "@seims/shared";

const EditParticipantsRoles = ({
  rolesData,
  visible,
  onCancel,
  onModalSubmit,
}) => {
  const [showOtherDuringProject, setShowOtherDuringProject] = useState(false);
  const [showOtherAfterProject, setShowOtherAfterProject] = useState(false);
  const [checkedConcepualList, setCheckedPreProjectList] = useState([]);
  const [checkedDuringRoleList, setCheckedDuringRoleList] = useState([]);
  const [checkedAfterRoleList, setCheckedAfterRoleList] = useState([]);
  const [checkedRoleList, setCheckedRoleList] = useState([]);
  const [contributionRecognition, setContributionRecognition] = useState([]);
  const [showOtherRole, setShowOtherRole] = useState(false);
  const [disabled, setDisabled] = useState(true);

  const [selectedPostProject, setSelectedPostProject] = useState([]);
  const [preProjectRoles, setPreProjectRoles] = useState([]);
  const [selectedPreProject, setSelectedPreProject] = useState([]);
  const [selectedDuringProject, setSelectedDuringProject] = useState([]);
  const [selectedProjectRecognition, setSelectedProjectRecognition] = useState(
    []
  );
  const [duringProject, setDuringProject] = useState([]);
  const [postProject, setPostProject] = useState([]);

  useEffect(() => {
    getConceptualizationStageRoles();
    getParticipantRolesDuring();
    getParticipantRolesPost();
    getContributionRecognition();
    loadProjectParticipantRoles();
  }, []);

  const getConceptualizationStageRoles = async () => {
    try {
      const response = await lookupApi.getParticipantRoles(
        csParticipRoleEnum.CONCEPTUALISATION
      );
      if (response) {
        const { data } = response;
        const transformData = data.map((c) => ({
          label: c.value,
          value: c.key,
          key: c.key,
        }));
        setPreProjectRoles(transformData);
      }
    } catch (error) {
      recordError(error);
    }
  };
  const getParticipantRolesDuring = async () => {
    try {
      const response = await lookupApi.getParticipantRoles(
        csParticipRoleEnum.DURING
      );
      if (response) {
        const { data } = response;
        const transformData = data.map((c) => ({
          label: c.value,
          value: c.key,
          key: c.key,
        }));
        setDuringProject(transformData);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getParticipantRolesPost = async () => {
    try {
      const response = await lookupApi.getParticipantRoles(
        csParticipRoleEnum.POST
      );
      if (response) {
        const { data } = response;
        const transformData = data.map((c) => ({
          label: c.value,
          value: c.key,
          key: c.key,
        }));

        setPostProject(transformData);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getProjectParticipantRolesPost = async () => {
    try {
      const response = await lookupApi.getParticipantRoles(true);
      if (response && response.status === 200) {
        const { data } = response;
        const treeData = transformKeyValue(data);
        setPostProject(treeData);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getProjectParticipantRolesDuring = async () => {
    try {
      const response = await lookupApi.getParticipantRoles(false);
      if (response && response.status === 200) {
        const { data } = response;
        const treeData = transformKeyValue(data);
        setDuringProject(treeData);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const loadProjectParticipantRoles = async () => {
    const _pre = rolesData.rolesPreProject?.map((d) => d.key);
    setSelectedPreProject(_pre);

    const _post = rolesData.rolesPostProject?.map((d) => d.key);
    setSelectedPostProject(_post);

    const _recognition = rolesData.contributionRecognition?.map((d) => d.key);
    setSelectedProjectRecognition(_recognition);

    const _during = rolesData.rolesDuringProject?.map((d) => d.key);
    setSelectedDuringProject(_during);

    form.setFieldsValue({
      rolesPreProject: _pre,
      rolesDuringProject: _during,
      rolesPostProject: _post,
      contributionRecognition: _recognition,
    });

    // if (rolesData.otherDuringRole !== undefined) {
    //   setShowOtherDuringProject(true);
    //   form.setFieldsValue({ otherDuringRole: rolesData.otherDuringRole });
    // }

    // if (rolesData.otherPostRole !== undefined) {
    //   setShowOtherAfterProject(true);
    //   form.setFieldsValue({ otherPostRole: rolesData.otherPostRole });
    // }

    // if (rolesData.otherRecognition !== undefined) {
    //   setShowOtherRole(true);
    //   form.setFieldsValue({ otherRecognition: rolesData.otherRecognition });
    // }
  };

  const getContributionRecognition = async () => {
    try {
      const response = await lookupApi.getContributionRecognitions();
      if (response) {
        const { data } = response;
        const transformData = transformKeyValue(data);
        setContributionRecognition(transformData);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const transformKeyValue = (keyValues) => {
    return keyValues?.map((d) => {
      return {
        label: d.value,
        value: d.key,
        key: d.key,
      };
    });
  };

  const [form] = Form.useForm();
  const formName = "EditParticipantRoles";

  const atLeastOneSelected = ({ getFieldValue }) => ({
    validator(_, value) {
      const duringProject = getFieldValue("rolesDuringProject");
      const postProject = getFieldValue("rolesPostProject");
      const conceptualizationProject = getFieldValue("rolesPreProject");
      if (
        (duringProject && duringProject.length > 0) ||
        (postProject && postProject.length > 0) ||
        (conceptualizationProject && conceptualizationProject.length > 0)
      ) {
        return Promise.resolve();
      }
      return Promise.reject(
        new Error(
          "Please select at least one option from either Conceptualisation, During or Post Project"
        )
      );
    },
  });

  const onChangeDuring = (selectedValue) => {
    const selectedOptions = duringProject?.filter((c) =>
      selectedValue.includes(c.key)
    );
    const otherSelected = selectedOptions.some((c) => c.label === "Other");

    if (otherSelected) {
      setShowOtherDuringProject(true);
    } else {
      setShowOtherDuringProject(false);
    }

    if (otherSelected) {
      setShowOtherDuringProject(true);
    } else {
      setShowOtherDuringProject(false);
    }
  };

  const onChangePreProject = (selectedValue) => {
    setCheckedPreProjectList(selectedValue);
  };

  const onChangePost = (selectedValue) => {
    // setCheckedAfterRoleList(keys);
    const selectedOptions = postProject?.filter((c) =>
      selectedValue.includes(c.key)
    );
    const otherSelected = selectedOptions.some((c) => c.label === "Other");

    if (otherSelected) {
      setShowOtherAfterProject(true);
    } else {
      setShowOtherAfterProject(false);
    }
  };

  const onChangeRoles = (keys) => {
    setCheckedRoleList(keys);
    const selectedOptions = contributionRecognition?.filter((c) =>
      keys.includes(c.key)
    );
    const otherSelected = selectedOptions.some((c) => c.label === "Other");

    if (otherSelected) {
      setShowOtherRole(true);
    } else {
      setShowOtherRole(false);
    }
  };

  const onChangeOtherRole = (e) => {
    const { value: text } = e.target;
    const id = checkedRoleList.indexOf("Other");
    if (id !== -1) checkedRoleList[id] = text;
  };

  const onChangeOtherDuring = (e) => {
    const { value: text } = e.target;
    const id = checkedDuringRoleList.indexOf("Other");
    if (id !== -1) checkedDuringRoleList[id] = text;
  };

  const onChangeOtherAfter = (e) => {
    const { value: text } = e.target;
    const id = checkedAfterRoleList.indexOf("Other");
    if (id !== -1) checkedAfterRoleList[id] = text;
  };

  const onPopCancel = () => {
    onCancel();
    setDisabled(true);
    //  form.resetFields();
  };

  const Confirm = () => {
    onCancel();
    form.resetFields();
  };

  const onSubmit = (values) => {
    let preData = [];

    values.rolesPreProject?.forEach((pre) => {
      const dd = preProjectRoles?.find((c) => c.key === pre);
      if (dd !== null) {
        preData.push({
          key: dd.key,
          value: dd.label,
        });
      }
    });

    let duringData = [];
    values.rolesDuringProject?.forEach((during) => {
      const dd = duringProject?.find((c) => c.key === during);
      if (dd !== null) {
        duringData.push({
          key: dd.key,
          value: dd.label,
        });
      }
    });

    let postData = [];
    values.rolesPostProject?.forEach((post) => {
      const dd = postProject?.find((c) => c.key === post);
      if (dd !== null) {
        postData.push({
          key: dd.key,
          value: dd.label,
        });
      }
    });

    let recognitionData = [];
    values.contributionRecognition?.forEach((recognition) => {
      const dd = contributionRecognition?.find((c) => c.key === recognition);
      if (dd !== null) {
        recognitionData.push({
          key: dd.key,
          value: dd.label,
        });
      }
    });

    rolesData.rolesPreProject = preData;
    rolesData.rolesDuringProject = duringData;
    // rolesData.otherDuringRole =
    //   values.otherDuringRole === undefined ? null : values.otherDuringRole;
    rolesData.rolesPostProject = postData;
    // rolesData.otherPostRole =
    //   values.otherPostRole === undefined ? null : values.otherPostRole;
    rolesData.contributionRecognition = recognitionData;
    // rolesData.otherRecognition =
    //   values.otherRecognition === undefined ? null : values.otherRecognition;
    onModalSubmit(rolesData);
  };

  return (
    <Modal
      title="Participant Roles - Edit"
      open={visible}
      closable={false}
      keyboard={false}
      maskClosable={false}
      onCancel={onCancel}
      width={1000}
      footer={[
        <div className="modal-footer-buttons">
          <Popconfirm
            key="2"
            title="Are you sure you want to cancel...you will lose all info entered?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => Confirm()}
            onCancel={onPopCancel}
            disabled={disabled}
          >
            <Button onMouseUp={() => onPopCancel()} style={{ marginLeft: 10 }}>
              Cancel
            </Button>
          </Popconfirm>
          <Button
            type="primary"
            htmlType="submit"
            onSubmit={onSubmit}
            form={formName}
          >
            Update
          </Button>
        </div>,
      ]}
    >
      <Form
        name={formName}
        form={form}
        onFinish={onSubmit}
        scrollToFirstError
        layout="vertical"
      >
          <Row>
            <Col>
              <div>
                <span
                  style={{
                    display: "inline-block",
                    marginRight: "4px",
                    color: "#ff4d4f",
                    fontSize: "14px",
                    fontFamily: "SimSun, sans-serif",
                    lineHeight: 1,
                  }}
                >
                  *
                </span>
                <b>
                  Specify at least one role the citizen scientist will play in the project
                </b>
              </div>
              <br />
            </Col>
          </Row>
        <Row>
          <Col xs={12} md={12}>
            <Row>
              <Col>
                <Form.Item
                  name="rolesPreProject"
                  label="Conceptualisation Stage"
                  dependencies={["rolesDuringProject", "rolesPostProject"]}
                  rules={[atLeastOneSelected(form)]}
                >
                  <Checkbox.Group
                    onChange={onChangePreProject}
                    options={preProjectRoles}
                    style={{ display: "flex", flexDirection: "column" }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Item
                  name="rolesDuringProject"
                  label="During project"
                  dependencies={["rolesPostProject", "rolesPreProject"]}
                  rules={[atLeastOneSelected(form)]}
                >
                  <Checkbox.Group
                    onChange={onChangeDuring}
                    options={duringProject}
                    style={{ display: "flex", flexDirection: "column" }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={12} md={12}>
            <Row>
              <Col>
                <Form.Item
                  name="rolesPostProject"
                  label="Post project"
                  dependencies={["rolesDuringProject", "rolesPreProject"]}
                  rules={[atLeastOneSelected(form)]}
                >
                  <Checkbox.Group
                    onChange={onChangePost}
                    options={postProject}
                    style={{ display: "flex", flexDirection: "column" }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>

        <Divider />
        <Row>
          <Col>
            <Form.Item
              name="contributionRecognition"
              label={ <p><b>Specify the manner in which you recognise the contribution of the citizen scientists</b></p> }
              rules={[
                {
                  required: true,
                  message:
                    "Please select at least one of the options before continuing",
                },
              ]}
            >
              <Checkbox.Group
                onChange={onChangeRoles}
                options={contributionRecognition}
                style={{ display: "flex", flexDirection: "column" }}
              />
            </Form.Item>
          </Col>
        </Row>
        {showOtherRole && (
          <Row>
            <Col>
              <Form.Item
                name="otherRecognition"
                label="Please enter other role"
                rules={[
                  {
                    required: true,
                    message: "Please provide other text",
                  },
                ]}
              >
                <Input onBlur={onChangeOtherRole} />
              </Form.Item>
            </Col>
          </Row>
        )}
      </Form>
    </Modal>
  );
};

export default EditParticipantsRoles;